const RightSectionLogin = () => (
  <div className='hidden w-full h-screen bg-avatar bg-cover bg-center lg:block'></div>
);

export default RightSectionLogin;
